export class AuthenticationMemo {
  static signIn(token: string, user: Object): void {
    localStorage.setItem("@showmusic:token", token);
    localStorage.setItem("@showmusic:user", JSON.stringify(user));
  }

  static SignOut(): void {
    localStorage.removeItem("@showmusic:token");
    localStorage.removeItem("@showmusic:user");
  }
}
